import CustomPagination from "@/components/Pagination/CustomPagination";
import {
  customPaginationPageSize,
  customPaginationPageSizeSelector,
  customTableLoadingData,
} from "@/components/Table/CustomPaginationConstants";
import Table from "@/components/Table/table";
import {
  useCreditorDistributionHeaders,
  useCreditorSettlementHeaders,
} from "@/features/creditor/claimsTab/Constant/CreditorDistributionHeaders";
import {
  MotifButton,
  MotifChip,
  MotifErrorMessage,
  MotifIcon,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useGetCreditorSettelmentListApiQuery,
  useGetPaymentListApiQuery,
  useLazyGetPaymentListApiQuery,
} from "./CreditorSummaryUpdate/CreditorSummaryReducer";
import { useParams } from "react-router-dom";
import { IconoirNavArrowDown, IconoirNavArrowUp } from "@ey-xd/motif-icon";
import { Filter } from "../PaymentStatus/payments/Filter";
import { useGetCalculationStepDataQuery } from "../CalculationStep/calculationStepSlice";
import { FormValues } from "../PaymentStatus/type";
import { useDispatch, useSelector } from "react-redux";
import { setComponentState1 } from "@/features/retain_state/retainStateSlice";
import {
  EXPORT_BUTTON_VARIANT,
  GetCommonDownloadImgButton,
} from "@/components/Images/CommonImages";
import { useLazyExportDocumentQuery } from "@/services/exports/exportsReducer";
import { commonFormateName } from "@/utility/common";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import { useLazyDownloadDocumentQuery } from "@/services/documents/documentsReducer";
import "./CreditorDistributions.scss"
function CreditorDistributions({ creditorDetails }: { creditorDetails: any }) {
  const { caseId, creditorId } = useParams<{
    creditorId: string;
    caseId: string;
  }>();
  const [selectedExportType, setSelectedExportType] = useState("");
  const settelmentRetainState = useSelector(
    (e: any) => e.retainState.creditorSettelmentTabState
  );
  const distributionRetainState = useSelector(
    (e: any) => e.retainState.creditorDistributionTabState
  );
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");

  const getPaginationObj: any = useMemo(() => {
    let value: any = {
      CaseId: caseId,
      CreditorId: creditorId,
      PageNumber: distributionRetainState.PageNumber,
      PageSize: distributionRetainState.PageSize,
      SearchText: distributionRetainState.SearchText,
    };
    if (
      distributionRetainState.SortOrder &&
      distributionRetainState.SortColumn
    ) {
      value.SortOrder = distributionRetainState.SortOrder;
      value.SortColumn = distributionRetainState.SortColumn;
    }
    return value;
  }, [distributionRetainState, caseId, creditorId]);
  const paginationObj = getPaginationObj;

  const getPaginationSettelmentObj: any = useMemo(() => {
    let value: any = {
      CaseId: caseId,
      CreditorId: creditorId,
      PageNumber: settelmentRetainState.PageNumber,
      PageSize: settelmentRetainState.PageSize,
      SearchText: settelmentRetainState.SearchText,
    };
    if (settelmentRetainState.SortOrder && settelmentRetainState.SortColumn) {
      value.SortOrder = settelmentRetainState.SortOrder;
      value.SortColumn = settelmentRetainState.SortColumn;
    }
    return value;
  }, [settelmentRetainState, caseId, creditorId]);
  const paginationSettelmentObj = getPaginationSettelmentObj;
  const [showFilter, setShowFilter] = useState(false);
  const filterPayload = useMemo(
    () => distributionRetainState.filterPayload || {},
    [distributionRetainState.filterPayload]
  );
  const isFilterActive = distributionRetainState.isFilterActive || false;
  const [
    triggerPaymentFilter,
    {
      data: paymentFilterData,
      isFetching: filterFetching,
      error: filterError,
      status: filterStatus,
    },
  ] = useLazyGetPaymentListApiQuery();
  const [formValues, setFormValues] = useState<FormValues>(
    distributionRetainState.formValues || {
      payeeName: "",
      accountName: "",
      prefix: "",
      paymentReferenceStartWith: "",
      paymentReferenceEndWith: "",
      issueStartDate: undefined,
      issueEndDate: undefined,
      lowerBound: "",
      upperBound: "",
      postedDateStart: undefined,
      postedDateEnd: undefined,
      paymentStatus: "",
    }
  );

  const {
    data: settelmentList,
    isLoading: settelmentListLoading,
    isFetching: settelmentListFetching,
    isError: settelmentListError,
    status: settelmentListStatus,
  } = useGetCreditorSettelmentListApiQuery(paginationSettelmentObj, {
    skip: !creditorId,
  });
  const {
    data,
    isLoading,
    isFetching,
    isError,
    status,
    refetch: refetchPaymentList,
  } = useGetPaymentListApiQuery(paginationObj, { skip: isFilterActive });
  const [downloadDocument] = useLazyDownloadDocumentQuery();
  let [documnetId, setDocumentId] = useState<any>("");

  useEffect(() => {
    if (isFilterActive) {
      const pageData = {
        ...paginationObj,
        PageNumber: paginationObj.PageNumber,
        CreditorId: creditorId,
      };
      triggerPaymentFilter({ ...filterPayload, ...pageData });
    } else {
      refetchPaymentList();
    }
  }, [
    paginationObj,
    filterPayload,
    refetchPaymentList,
    isFilterActive,
    triggerPaymentFilter,
    creditorId,
  ]);
  const { data: accountData } = useGetCalculationStepDataQuery({
    caseId: caseId,
  });
  const accountList =
    (accountData &&
      accountData?.map((item: any) => ({
        name: item.accountName || item.name,
        id: item.accountId || item.id,
      }))) ||
    [];
  const { t } = useTranslation();
  const actionRenderer = {
    checqDownloadRenderer: function (params: any) {
      return params?.data?.documentId ? (
        <GetCommonDownloadImgButton
          onClick={() => {
            setDocumentId(params.data.documentId);
            downloadDocument({
              caseId: caseId,
              documentId: params.data.documentId,
              fileName: params?.data?.fileName,
            })
              .then(() => {
                setDocumentId(null);
              })
              .catch(() => {
                setDocumentId(null);
              });
          }}
          loading={params?.selectedDoumnetId === params.data.documentId}
        ></GetCommonDownloadImgButton>
      ) : (
        <></>
      );
    },
  };
  const columnDefs = useCreditorDistributionHeaders({
    creditorDetails,
    documnetId,
  });
  const settelmentColumnDefs = useCreditorSettlementHeaders({
    creditorDetails,
  });
  function handlePaginationData(data: any, columnTypesData: any) {
    dispatch(
      setComponentState1({
        entityName: "creditorDistributionTabState",
        entityState: {
          SortOrder: data.SortOrder,
          SortColumn: data.SortColumn,
          sortedColumnTypes: columnTypesData,
        },
      })
    );
  }
  function handleSettelmentPaginationData(data: any, columnTypesData: any) {
    dispatch(
      setComponentState1({
        entityName: "creditorSettelmentTabState",
        entityState: {
          SortOrder: data.SortOrder,
          SortColumn: data.SortColumn,
          sortedColumnTypes: columnTypesData,
        },
      })
    );
  }
  const clearFilter = () => {
    setFormValues((prevValues: any) => ({
      ...prevValues,
      payeeName: "",
      accountName: "",
      prefix: "",
      paymentReferenceStartWith: "",
      paymentReferenceEndWith: "",
      issueStartDate: undefined,
      issueEndDate: undefined,
      lowerBound: "",
      upperBound: "",
      postedDateStart: undefined,
      postedDateEnd: undefined,
      paymentStatus: "",
      statusUpdateStartDate: undefined,
      statusUpdateEndDate: undefined,
    }));
    setShowFilter(false);
    dispatch(
      setComponentState1({
        entityName: "creditorDistributionTabState",
        entityState: {
          showFilter: false,
          isFilterActive: false,
          formValues: null,
          pageNumber: 1,
          SortOrder: "asc",
          SortColumn: "PaymentReference",
          sortedColumnTypes: resetSortStatus("paymentReference"),
        },
      })
    );
  };

  let resetSortStatus = useCallback(
    (defaultSort: string) => {
      let json: any = { ...distributionRetainState.sortedColumnTypes };
      for (const key in json) {
        json[key] = { sort: null };
      }
      json[defaultSort] = { sort: "asc" };
      return json;
    },
    [distributionRetainState]
  );
  const handleFilter = useCallback(
    (searchParams: any, formValues: any) => {
      setShowFilter((prev: any) => !prev);
      dispatch(
        setComponentState1({
          entityName: "creditorDistributionTabState",
          entityState: {
            showFilter: false,
            isFilterActive: true,
            filterPayload: searchParams,
            PageSize: customPaginationPageSize,
            formValues: formValues,
            PageNumber: 1,
            SearchText: "",
            SortOrder: "asc",
            SortColumn: "PaymentReference",
            sortedColumnTypes: resetSortStatus("paymentReference"),
          },
        })
      );
    },
    [resetSortStatus, dispatch]
  );
  const { caseShortName, abbreviation } = useSelector(
    (state: any) => state.case
  );
  const [exportDocument, { isFetching: exportFetching }] =
    useLazyExportDocumentQuery();

  function handleExport(url: string, requestBody: any, entityType: any) {
    exportDocument({
      url,
      fileName: caseShortName
        ? commonFormateName(
            caseShortName,
            creditorDetails?.creditorName
              ? creditorDetails.creditorName
              : "Creditor",
            abbreviation,
            entityType
          )
        : "",
      ...requestBody,
    })
      .then((response) => {
        if (response?.error && "data" in response.error) {
          try {
            const errObj = JSON.parse(response?.error?.data as string);
            setErrorMessage(errObj?.message || errObj.title);
          } catch (error) {
            setErrorMessage("Something went wrong!!");
          }
        }
      })
      .catch((error: any) => {
        setErrorMessage("Something went wrong!!");
      });
  }
  if (isError) {
    return (
      <MotifErrorMessage className="motif-row justify-content-center">
        {t("global.globalNotifications.wentWrong")}
      </MotifErrorMessage>
    );
  }
  const tableData = isFilterActive ? paymentFilterData?.results : data?.results;
  const tableFetching = isFilterActive ? filterFetching : isFetching;
  const tableError = isFilterActive ? filterError : isError;
  const disabledNext = isFilterActive
    ? paymentFilterData?.hasMoreRecords
    : data?.hasMoreRecords;
  const apiRes = isFilterActive ? paymentFilterData : data;
  const apiStatus = isFilterActive ? filterStatus : status;
  return (
    <>
      {errorMessage && (
        <NotificationGrid
          show={true}
          message={errorMessage}
          type="error"
          onClose={() => setErrorMessage("")}
        />
      )}
      <div className="motif-table-title-bar creditor_distribution_filter_wrapper">
        <div className="motif-table-info">
          <span className="motif-table-title">
            {t("pages.paymentStatus.filterForm.title")}
          </span>
          <span className="motif-table-description">
            {t("pages.paymentStatus.filterForm.description")}
          </span>
        </div>
        <MotifButton
          type="button"
          onClick={() => {
            setShowFilter((prev: any) => !prev);
          }}
          variant="secondary"
          size="small"
        >
          {t("pages.paymentStatus.filterForm.filterButton")}
          <MotifIcon
            aria-label="Dropdown icon"
            fill="none"
            iconFunction={showFilter ? IconoirNavArrowUp : IconoirNavArrowDown}
          />
        </MotifButton>
      </div>
      {showFilter && (
        <Filter
          accountList={accountList}
          setShowFilter={setShowFilter}
          onApply={handleFilter}
          formValues={formValues}
          setFormValues={setFormValues}
          clearFilter={clearFilter}
        />
      )}
      <br></br>
      {isLoading ? (
        <MotifProgressLoader show variant="default" className="mar-b-20" />
      ) : (
        <div className={"mar-b-20"}>
          <Table
            columnTypes={{ ...distributionRetainState.sortedColumnTypes }}
            handlePaginationData={handlePaginationData}
            paginationObj={paginationObj}
            columnDefs={columnDefs}
            title={"pages.creditors.creditorDistributionTab.tableTitle"}
            TitleComplement={() => (
              <div className="motif-row">
                {" "}
                {isFilterActive && (
                  <MotifChip
                    className="clear-search-chip"
                    onClick={clearFilter}
                    variant="monochrome-dark"
                  >
                    {t("pages.paymentStatus.clearFilter")}
                  </MotifChip>
                )}
                <MotifButton
                  onClick={() => {
                    let pageData = { ...paginationObj };
                    if (isFilterActive) {
                      pageData = {
                        ...filterPayload,
                        ...paginationObj,
                        PageNumber: paginationObj.PageNumber,
                        CreditorId: creditorId,
                      };
                    }
                    setSelectedExportType("PaymentList");

                    handleExport(
                      "Payment/ExportPaymentListByCreditor",
                      pageData,
                      "PaymentList"
                    );
                  }}
                  loading={
                    exportFetching && selectedExportType === "PaymentList"
                  }
                  className="mar-r-10"
                  variant={EXPORT_BUTTON_VARIANT}
                >
                  {t("global.globalActions.export")}
                </MotifButton>
              </div>
            )}
            description={
              "pages.creditors.creditorDistributionTab.tableDescription"
            }
            cellRenderers={tableData && !tableFetching ? tableData : []}
            caseRenderers={actionRenderer}
            pagination={false}
            overlayNoRowsTemplate={
              tableFetching
                ? t(customTableLoadingData)
                : tableError
                ? t("global.globalNotifications.wentWrong")
                : t("global.globalNotifications.noRecords")
            }
          />
          {
            <CustomPagination
              apiData={apiRes}
              apiStatus={apiStatus}
              currentpage={paginationObj.PageNumber}
              pageSize={paginationObj.PageSize}
              disableNext={!disabledNext}
              onChangePageSize={(page: number) => {
                dispatch(
                  setComponentState1({
                    entityName: "creditorDistributionTabState",
                    entityState: {
                      PageSize: page,
                      PageNumber: 1,
                    },
                  })
                );
              }}
              onChangeNextPage={() => {
                dispatch(
                  setComponentState1({
                    entityName: "creditorDistributionTabState",
                    entityState: {
                      PageNumber: paginationObj.PageNumber + 1,
                    },
                  })
                );
              }}
              onChangePreviousPage={() => {
                dispatch(
                  setComponentState1({
                    entityName: "creditorDistributionTabState",
                    entityState: {
                      PageNumber: paginationObj.PageNumber - 1,
                    },
                  })
                );
              }}
              pageSizeSelector={customPaginationPageSizeSelector}
            />
          }
        </div>
      )}
        {settelmentListLoading ? (
        <MotifProgressLoader show variant="default" className="mar-b-20" />
      ) : (
        <div className={"mar-b-20"}>
          <Table
            columnTypes={{ ...settelmentRetainState.sortedColumnTypes }}
            handlePaginationData={handleSettelmentPaginationData}
            paginationObj={paginationSettelmentObj}
            columnDefs={settelmentColumnDefs}
            title={
              "pages.creditors.creditorDistributionTab.settelmentTableTitle"
            }
            TitleComplement={() => {
              return (
                <>
                  {" "}
                  <MotifButton
                    onClick={() => {
                      setSelectedExportType("settlement");
                      handleExport(
                        "/Payment/ExportSettlementListByCreditor",
                        paginationSettelmentObj,
                        "Settlements"
                      );
                    }}
                    loading={
                      exportFetching && selectedExportType === "settlement"
                    }
                    className="mar-r-10"
                    variant={EXPORT_BUTTON_VARIANT}
                  >
                    {t("global.globalActions.export")}
                  </MotifButton>
                </>
              );
            }}
            description={
              "pages.creditors.creditorDistributionTab.settelmentTableDescription"
            }
            cellRenderers={
              settelmentList?.results && !settelmentListFetching
                ? settelmentList.results
                : []
            }
            pagination={false}
            overlayNoRowsTemplate={
              settelmentListFetching
                ? t(customTableLoadingData)
                : settelmentListError
                ? t("global.globalNotifications.wentWrong")
                : t("global.globalNotifications.noRecords")
            }
          />
          {
            <CustomPagination
              apiData={settelmentList}
              apiStatus={settelmentListStatus}
              currentpage={paginationSettelmentObj.PageNumber}
              pageSize={paginationSettelmentObj.PageSize}
              disableNext={!settelmentList?.hasMoreRecords}
              onChangePageSize={(page: number) => {
                dispatch(
                  setComponentState1({
                    entityName: "creditorSettelmentTabState",
                    entityState: {
                      PageSize: page,
                      PageNumber: 1,
                    },
                  })
                );
              }}
              onChangeNextPage={() => {
                dispatch(
                  setComponentState1({
                    entityName: "creditorSettelmentTabState",
                    entityState: {
                      PageNumber: paginationSettelmentObj.PageNumber + 1,
                    },
                  })
                );
              }}
              onChangePreviousPage={() => {
                dispatch(
                  setComponentState1({
                    entityName: "creditorSettelmentTabState",
                    entityState: {
                      PageNumber: paginationSettelmentObj.PageNumber - 1,
                    },
                  })
                );
              }}
              pageSizeSelector={customPaginationPageSizeSelector}
            />
          }
        </div>
      )}
    </>
  );
}

export default CreditorDistributions;
